import React, { useState, useEffect } from 'react';

const OfferTimer = () => {
  const calculateTimeLeft = () => {
    const now = new Date().getTime();
    const storedEndTime = localStorage.getItem('offerEndTime');

    let endTime;
    if (storedEndTime && now < parseInt(storedEndTime)) {
      endTime = parseInt(storedEndTime);
    } else {
      endTime = now + 2 * 24 * 60 * 60 * 1000; // 2 days
      localStorage.setItem('offerEndTime', endTime);
    }

    const difference = endTime - now;

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
      endTime,
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      const newTime = calculateTimeLeft();
      setTimeLeft(newTime);

      // If expired, reset
      if (
        newTime.days <= 0 &&
        newTime.hours <= 0 &&
        newTime.minutes <= 0 &&
        newTime.seconds <= 0
      ) {
        const newEndTime = new Date().getTime() + 2 * 24 * 60 * 60 * 1000;
        localStorage.setItem('offerEndTime', newEndTime);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{
      textAlign: 'center',
      background: '#D9D9D9',
      padding: '15px',
      fontWeight: 'bold',
      fontSize: '20px',
      color: '#000',
      position: 'relative', // Keeps the position relative to its parent container
      zIndex: 2,            // Ensures it's below the header
      width: '100%',
      marginTop: '30px'     // Adjust the margin to give space below the header
    }}>
      ⏰ Hurry! Offer ends in {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
    </div>
  );
};

export default OfferTimer;
